export default "__VITE_ASSET__BfPirfWk__"